import type { ProductListItem } from "@labeling-tools/api/field-rep/generated/types.gen";
import { ProductProposal } from "@/types/trackLabeling";

/** The subset of the product-set API item the grid needs. */
export type ProductSetItem = Pick<
  ProductListItem,
  "id" | "title" | "price" | "primary_image" | "variant" | "cluster"
>;

/** Maps a product-set API item into the ProductProposal shape used by the grid. */
export function toProductSetProposal(item: ProductSetItem): ProductProposal {
  return {
    product_id: item.id,
    title: item.title,
    price: item.price == null ? null : Number(item.price),
    final_score: 0,
    fromProductSet: true,
    variant: item.variant,
    cluster: item.cluster,
    imageUrl: item.primary_image?.signed_url,
  };
}

/** Maps a product the recognizer proposed for the track, with its best score, for the grid. */
export function toRecognizerProposal(
  item: ProductSetItem,
  finalScore: number,
): ProductProposal {
  return {
    ...toProductSetProposal(item),
    final_score: finalScore,
    fromProductSet: false,
  };
}
